import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Anonymous per-browser device id. No login.
function getDeviceId() {
  let id = localStorage.getItem('ctl_device_id');
  if (!id) {
    if (typeof crypto !== 'undefined' && crypto.randomUUID) {
      id = crypto.randomUUID();
    } else {
      id = 'd-' + Math.random().toString(36).slice(2) + Date.now().toString(36) + Math.random().toString(36).slice(2);
    }
    localStorage.setItem('ctl_device_id', id);
  }
  return id;
}

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  config.headers['X-Device-Id'] = getDeviceId();
  return config;
});

export const resetDeviceId = () => {
  localStorage.removeItem('ctl_device_id');
};
